module.exports = __webpack_public_path__ + "static/media/parallax-1.c2a1731f.jpg";